module.exports = __webpack_public_path__ + "assets/img/1517facaee4353d30e1865cd199f66e6.png";